// extracted by mini-css-extract-plugin
export default {"ellipsis":"EZcGHc77OUsJssYCH4n8","wrapper":"nZYHjyOr5B1krChf9vgw","viewDealsBtn":"M2IUsUWw7zkJfoVkIidr","spin":"m9npUJG1CFKExxo4IYXn"};